import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "suppressSensitive",
})
export class SuppressSensitivePipe implements PipeTransform {
    private readonly _suppressChar: string = "●";

    public transform(stringToSuppress: string): string {
        if (stringToSuppress.length <= 4) {
            return this._suppressChar.repeat(stringToSuppress.length);
        }

        if (stringToSuppress.length <= 8) {
            return this._suppressChar.repeat(4) + stringToSuppress.substring(4);
        }

        return this._suppressChar.repeat(stringToSuppress.length - 4) + stringToSuppress.substring(stringToSuppress.length - 4);
    }
}
